// MinistryHub logo lockups — uses the uploaded brand PNG/WEBP assets.
// Do not recreate the logo; these render the official assets only.
const BASE = "/brand";

// Full primary lockup (mark + "MinistryHub" wordmark). Use by default anywhere a full logo appears.
export function Logo({ theme = "black", height = 28, className = "", ...rest }) {
  const src = theme === "white" ? `${BASE}/mh-primary-white.webp` : `${BASE}/mh-primary-black.webp`;
  return <img src={src} alt="MinistryHub" style={{ height }} className={`w-auto ${className}`} {...rest} />;
}

// Icon-only brand mark. Use for compact nav, loading, favicons, small placements.
export function LogoMark({ theme = "black", size = 32, className = "", ...rest }) {
  const src = theme === "white" ? `${BASE}/mh-mark-white.webp` : `${BASE}/mh-mark-black.webp`;
  return <img src={src} alt="MinistryHub" width={size} height={size} className={className} {...rest} />;
}

// Vertical lockup. Use only where a stacked logo is clearly more appropriate.
export function LogoStacked({ height = 120, className = "", ...rest }) {
  return <img src={`${BASE}/mh-stacked-black.webp`} alt="MinistryHub" style={{ height }} className={`w-auto ${className}`} {...rest} />;
}
